(function () {
  function initParlezNavigation() {
    var navs = document.querySelectorAll('.parlez-slide-menu');
    navs.forEach(function (nav) {
      var triggers = nav.querySelectorAll('[data-parlez-panel-trigger]');
      var panels = nav.querySelectorAll('[data-parlez-panel]');
      function showPanel(panelId, activeTrigger) {
        panels.forEach(function (panel) {
          panel.classList.toggle('is-active', panel.getAttribute('data-parlez-panel') === panelId);
        });
        triggers.forEach(function (trigger) {
          trigger.classList.toggle('is-active', trigger === activeTrigger);
        });
      }
      function showDefaultPanel() {
        showPanel('default', null);
      }
      function triggerHasChildren(trigger) {
        return trigger.querySelector('.parlez-panel-nav__arrow') !== null;
      }
      nav.addEventListener('toggle', function () {
        if (nav.open) {
          document.body.classList.add('parlez-menu-open');
          showDefaultPanel();
        } else {
          document.body.classList.remove('parlez-menu-open');
          showDefaultPanel();
        }
      });

      // Hovering the top-level nav item opens the drawer; moving away closes it.
      nav.addEventListener('mouseenter', function () {
        nav.open = true;
      });

      nav.addEventListener('mouseleave', function () {
        nav.open = false;
      });

      triggers.forEach(function (trigger) {
        // Hovering always previews the panel, whether or not the item has children.
        trigger.addEventListener('mouseenter', function () {
          showPanel(trigger.getAttribute('data-parlez-panel-trigger'), trigger);
        });
        trigger.addEventListener('focus', function () {
          showPanel(trigger.getAttribute('data-parlez-panel-trigger'), trigger);
        });
        // Clicking only intercepts navigation for items that have sub-links to show.
        // Leaf items (no children) navigate straight to their own URL as normal.
        trigger.addEventListener('click', function (event) {
          if (triggerHasChildren(trigger)) {
            event.preventDefault();
            showPanel(trigger.getAttribute('data-parlez-panel-trigger'), trigger);
          }
        });
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && nav.open) {
          nav.open = false;
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParlezNavigation);
  } else {
    initParlezNavigation();
  }
})();